import { Injectable } from '@angular/core';
import { MainService } from './portal/service/main.service'
import { session } from '../environments/environment.session';
import { Utf8EncodingService } from './md/service/utf8-encoding.service';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(public mainService: MainService, private utf8EncodingService: Utf8EncodingService, private authenticationService: AuthenticationService) { }

  erpUser:any;
  allComponentCode:any = [];
  private authPromise: Promise<boolean> | null = null;

  public isAuthenticated(): Promise<boolean> {
    if (this.authPromise) {
      return this.authPromise;
    }
    this.authPromise = this._isAuthenticated();
    return this.authPromise.finally(() => {
      this.authPromise = null;
    });
  }

  private async _isAuthenticated(): Promise<boolean> {
    // If session is empty (e.g. page was refreshed), we must fetch the user before checking roles
    if (!session.erpUser || session.erpUser === 'undefined') {
      let resp = await this.authenticationService.getErpUser({});
      if (resp && resp['error'] == false) {
        let rawErpUser: string = resp['data'][0]['erpUser'];
        let erpUserStr: string = rawErpUser;
        try {
          const parsed = JSON.parse(rawErpUser);
          if (typeof parsed === 'string') erpUserStr = parsed;
        } catch { }
        session.erpUser = this.utf8EncodingService.encodeToUtf8(erpUserStr);
      } else {
        return false; // Authentication failed
      }
    }

    try {
      this.erpUser = this.utf8EncodingService.decodeFromUtf8(session.erpUser);
    } catch (e) {
      return false;
    }

    if (!this.erpUser) return false;

    this.allComponentCode = this.erpUser.assigned_component;

    if (this.allComponentCode == undefined || this.allComponentCode.length == 0) {
      this.allComponentCode = await this.getAllAssignedComponent(this.erpUser.b_acct_id, this.erpUser.role_cd);

      var erpUser1 = this.utf8EncodingService.decodeFromUtf8((session.erpUser));

      erpUser1['assigned_component'] = this.allComponentCode;
      // session['erpUser']=btoa(JSON.stringify(erpUser1));
      session['erpUser']=this.utf8EncodingService.encodeToUtf8(JSON.stringify(erpUser1));
    }

    if (this.allComponentCode != undefined && this.allComponentCode != null && this.allComponentCode.length > 0) {
      if (this.mainService.componentCode != undefined) {
        let isMatch = this.allComponentCode.indexOf(this.mainService.componentCode);
        if (isMatch == -1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }

    } else {
      return true;
    }

  }

  async getAllAssignedComponent(b_acct_id:any, role_cd:any) {
    let obj:any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var allComponentCode1 = [];
    var resp = await this.mainService.getAllAssignedComponents(JSON.stringify(obj));
    if (resp['error'] == false) {
      for (let i = 0; i < resp['data'].length; i++) {
        allComponentCode1.push(resp['data'][i]['resource_cd'])
      }
    } else {

    }
    return allComponentCode1;


  }
}
